import { generateUniqueId } from '@/helpers/uuidUtils';

export class DeviceService {
  id: string;
  type?: string;
  reason?: string;
  deviceId?: string;
  newDeviceId?: string;
  note?: string;
  timestamp: string;
  deviceVerificationStatus: TKDVerificationStatus;
  batteryVerificationStatus: TKDVerificationStatus;

  constructor() {
    this.id = generateUniqueId();
    this.type = undefined;
    this.note = undefined;
    this.reason = undefined;
    this.deviceId = undefined;
    this.newDeviceId = undefined;
    this.timestamp = new Date().toISOString();
    this.deviceVerificationStatus = new TKDVerificationStatus();
    this.batteryVerificationStatus = new TKDVerificationStatus();
  }
}

export class TKDVerificationStatus {
  id: string;
  isVerificationNotPossible: boolean;
  reason?: string;
  note?: string;

  constructor() {
    this.id = generateUniqueId();
    this.isVerificationNotPossible = false;
    this.reason = undefined;
    this.note = undefined;
  }
}
